import React from "react";
import { MailOutline } from "@mui/icons-material";

const TicketStatsCards = ({ ticketData, onCardClick }) => {
  // Calculate statistics from ticket data
  const calculateStats = () => {
    if (!Array.isArray(ticketData)) {
      return { total: 0, open: 0, closed: 0, assigned: 0, resolved: 0 };
    }

    const stats = {
      total: ticketData.length,
      open: 0,
      closed: 0,
      assigned: 0,
      resolved: 0,
    };

    ticketData.forEach((ticket) => {
      const status = (ticket.statusLabel || ticket.status || "").toLowerCase();
      switch (status) {
        case "open":
          stats.open++;
          break;
        case "closed":
          stats.closed++;
          break;
        case "assigned":
          stats.assigned++;
          break;
        case "resolved":
          stats.resolved++;
          break;
        default:
          break;
      }
    });

    return stats;
  };

  const stats = calculateStats();

  const cards = [
    {
      title: "Total Tickets",
      value: stats.total,
      color: "text-red-500",
      statusFilter: "All",
    },
    {
      title: "Closed Tickets",
      value: stats.closed,
      color: "text-green-500",
      statusFilter: "Closed",
    },
    {
      title: "Open Tickets",
      value: stats.open,
      color: "text-orange-400",
      statusFilter: "Open",
    },
    {
      title: "Assigned Tickets",
      value: stats.assigned,
      color: "text-blue-500",
      statusFilter: "Assigned",
    },
    {
      title: "Resolved Tickets",
      value: stats.resolved,
      color: "text-purple-500",
      statusFilter: "Resolved",
    },
  ];

  const handleCardClick = (statusFilter) => {
    if (onCardClick) onCardClick(statusFilter);
  };

  return (
    <div className="flex gap-4 mb-6 mt-4 w-full">
      {cards.map((card, index) => (
        <div
          key={index}
          onClick={() => handleCardClick(card.statusFilter)}
          className={`bg-white p-4 rounded-md border border-gray-100 shadow-sm flex-1 min-w-[200px] hover:shadow-md hover:border-gray-300 transition-all duration-200 ${
            onCardClick ? "cursor-pointer" : ""
          }`}
        >
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <h3 className="text-sm font-medium text-gray-500 mb-2 font-ubuntu">
                {card.title}
              </h3>
              <p className={`text-2xl font-bold font-ubuntu ${card.color}`}>{card.value}</p>
            </div>
            <div className="flex-shrink-0 ml-3">
              <MailOutline sx={{ fontSize: 24, color: "#e2e8f0" }} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TicketStatsCards;

